import React, { useContext, useRef,useCallback } from "react";
import { request } from "./request";
import {
    AnyType,
    PlatformEnum,
    MethodEmun,
    Commond,
    ConfefenctType,
    ConferenceInterface,
  } from "@/types";
export const recordComplete = (params: any) => {
    return request({
        url: "/qrtc-conference/conference/recordCompleted",
        params,
        method: MethodEmun.post,
    });
}